export default {
	user(state) {
		return state.user
	},
	menus(state) {
		const {menus, menuIcons, user} = state
		const type = user?.user?.type
		try {
			return menus[type].map((v, i) => {
				return {
					...v,
					index: '#'+i,
					icon: menuIcons[i % (menuIcons.length)]
				}
			})
		} catch (e) {}
		return []
	},
	registerTypes(state) {
		return state.registerTypes
	}
}